module.exports = __webpack_public_path__ + "static/WSC_Group_2016_Self-Managed_Superfund_Checklist-b1f13b4aad04981ba194b36262c10878.pdf";